import logoNoronCar from '../Images/logo.png'
import { toast } from "react-toastify";
import service from "../Services/services";
import { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
export default function PaymentResult() {
  //const { id } = useParams();
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [factorId, setFactorId] = useState(0)
  const [transId, setTransId] = useState(0)
  const [idGet, setIdGet] = useState(0)


  useEffect(() => {
     console.log('1');
     try{
    const trans_id = searchParams.get('trans_id');
    const id_get = searchParams.get('id_get');
    const factor_Id = searchParams.get('factorId');
   
    setFactorId(factor_Id);
    setTransId(trans_id); 
    setIdGet(id_get); 
     }catch{console.log('error')}
    console.log('2')
  }, []);

  useEffect(() => {
    if (idGet>0 && transId>0 && factorId>0)
      doVerify(idGet,transId,factorId);
  }, [idGet, transId,factorId]);

  const [result,setResult]=useState("")

  const [isVeifying, setIsVerify] = useState(false);
  const doVerify = async (idGet,transId,factorId) => {
    setIsVerify(true);
    setResult("")
    await service.Verify(idGet,transId,factorId)
      .then(({ data }) => {
        setIsVerify(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
       // toast.dark('پرداخت شما تایید شد')
        setResult(data.payload)
      })
      .catch(err => {
        setIsVerify(false);
      });
  }

  return (
    <>
      <div className='row mt-3'>
        <div className='col'>
          <div className={`alert ${result==""?"alert-primary":result=="OK"?"alert-success":"alert-danger"}`} role="alert">
            <h4 className="alert-heading">توجه</h4>
            {result == "OK" && <>پرداخت موفق. </>}
            {(result != "OK" && result!="") && <>خطا در پرداخت ...</>}
            {isVeifying &&
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>}
          </div>
        </div>
      </div>
      <div className="row mt-4 mb-4 ">
        <div className="col d-flex  justify-content-center">
          <Link to="/login" ><img src={logoNoronCar} className="img-fluid rounded-circle iconLink mx-2 shadow" alt="logoWeb" />بازگشت</Link>
        </div>
      </div>
    </>
  );
}

